/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useLedgerUrl } from 'domain/shared/ledger';

const LedgerBreadcrumbs = ({ children }: { children: React.ReactNode }) => {
  const { getListUrl } = useLedgerUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Ledger" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default LedgerBreadcrumbs;
